import React from "react";
import {
   Avatar,
   borderRadius,
   Box,
   colors,
   Flex,
   Grid,
   H3,
   Typography,
   useI18nContext,
} from "@procore/core-react";
import { Person } from "@procore/core-icons";
import classnames from "classnames";
import { getInitials, formatActivityTimestamp } from "../../tearsheets/project/helpers";
import { getFullName } from "../../tearsheets/people/tearsheet-utils";
import styles from "../../tearsheets/project/project-detail-cards/project-details.scss";
import type { ActivityCardProps } from "./types";
import { CONTENT_INSET } from "./constants";
const cx = classnames.bind(styles);

export const ActivityCard = ({ activity, renderActivityContent, footer }: ActivityCardProps) => {
   const I18n = useI18nContext();
   const authorName = getFullName(activity.author_name ?? undefined);
   const isSystemAuthor = activity.via_integration || !!activity.system_action;
   const content = renderActivityContent(activity);

   return (
      <Box
         padding="lg"
         marginBottom="sm"
         className={cx("custom-card")}
         style={{ backgroundColor: colors.white, borderRadius: borderRadius.md }}
      >
         <Grid>
            <Grid.Row>
               <Grid.Col>
                  <Flex alignItems="center" gap="md">
                     <Avatar>
                        {isSystemAuthor ? (
                           <Avatar.Icon icon={<Person size="sm" />} />
                        ) : (
                           <Avatar.Label>{getInitials(authorName)}</Avatar.Label>
                        )}
                     </Avatar>
                     <Flex alignItems="baseline" wrap="wrap" gap="sm">
                        <H3>{authorName}</H3>
                        <Typography color="gray45">
                           {formatActivityTimestamp(activity.created_at, I18n)}
                        </Typography>
                     </Flex>
                  </Flex>
               </Grid.Col>
            </Grid.Row>
            {content && (
               <Grid.Row>
                  <Grid.Col>
                     <Box style={{ marginLeft: CONTENT_INSET }}>{content}</Box>
                  </Grid.Col>
               </Grid.Row>
            )}
            {footer && (
               <Grid.Row>
                  <Grid.Col>
                     <Box paddingTop="sm" style={{ marginLeft: CONTENT_INSET }}>
                        <Typography intent="body">{footer}</Typography>
                     </Box>
                  </Grid.Col>
               </Grid.Row>
            )}
         </Grid>
      </Box>
   );
};
